module.exports = __webpack_public_path__ + "img/solaris_logo_text_1000w.c2e01689.png";